module.exports = __webpack_public_path__ + "static/media/ImageSix.d94e2543.jpg";